import { ContractTypeEnum } from '@/views/ContractManagement/enums';

/**
 * v5 창구가 쓰는 계약유형 — v1 목록에 **물품매매V5 한 종만 더한** 것.
 *
 * 왜 공용 `ContractManagement/enums.js` 에 직접 넣지 않는가:
 *   운영 중인 v3 창구가 그 파일을 import 한다. v5 를 짓는 동안 v3 가 읽는 값은 바이트 단위로
 *   그대로여야 하고, `scripts/contracts-v5-preserve-check.js` 가 v3 의존 공유 파일로 이 파일의
 *   무변경을 강제한다. 한 줄 추가조차 그 보증을 깨므로 v5 쪽에서 확장한다.
 *   (v1 창구는 2026-08-28 제거됐다. 이 파일은 이름만 v1 폴더에 있을 뿐 v2·v3·v5 공용이다.)
 *
 * [HARD] 값 문자열은 백엔드 `ContractTypeEnum.물품매매V5`(contracts-api
 * `src/contracts/enums/contract-type.enum.ts`)와 **정확히 같아야 한다**. 달라지면 발행 요청이
 * 매퍼 레지스트리에서 "생성 가능한 계약유형이 아닙니다" 로 떨어진다.
 *
 * 화면이 `ContractTypeEnum.물품매매V5` 로 바로 읽으면 값이 `undefined` 가 되는데, JS 는 그걸
 * 오류로 만들지 않는다 — 빌드는 초록이고 발행 시점에야 터진다. 그래서 여기 모아 둔다.
 */
export const ContractTypeEnumV5 = Object.freeze({
  ...ContractTypeEnum,
  물품매매V5: '물품매매V5',
  // 물품매매V6(2차 개정 서식, MulpumTypeV6.vue) — 값은 백엔드
  // `ContractTypeEnum.물품매매V6`(contracts-api dentium-product-sale-v6.create.dto.ts 참조
  // 모듈의 enum 등록)과 정확히 같아야 한다. 위 물품매매V5 와 동일한 이유로 공용 enums.js 에
  // 직접 넣지 않고 여기서 확장한다.
  물품매매V6: '물품매매V6',
});
